import { Box, Grid, Switch } from '@mui/material';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { WsTypography } from 'wisestep-base';

import { switchDialogHelper } from '../../../utils/campaignHelper';
import { SwitchDialog } from '../switchDialog';

export const enum TOGGLE_VARIANT {
  ACTIVE,
  ENABLE,
}

interface CampaignHeaderProps {
  name: string;
  children: React.ReactNode;
  variant?: TOGGLE_VARIANT;
  skip?: boolean;
}

const ToggleValue = {
  [TOGGLE_VARIANT.ACTIVE]: {
    true: 'Active',
    false: 'Inactive',
  },
  [TOGGLE_VARIANT.ENABLE]: {
    true: 'Enabled',
    false: 'Disabled',
  },
};

export const CampaignHeader = ({
  name,
  children,
  skip = false,
  variant = TOGGLE_VARIANT.ACTIVE,
}: CampaignHeaderProps) => {
  const { control, watch, setValue } = useFormContext();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const handleConfirm = (onChange: (val: boolean) => void, val) => {
    if (switchDialogHelper[name].alteredField)
      setValue(switchDialogHelper[name].alteredField, false);
    onChange(val);
    handleCancel();
  };
  const handleCancel = () => setOpenDialog(false);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {children}
      <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
        <WsTypography>{ToggleValue[variant][watch(name) ?? false]}</WsTypography>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Grid ml={1}>
              <>
                <Grid ml={1}>
                  <Switch
                    checked={value}
                    onChange={(_, checked) => {
                      checked && !skip ? setOpenDialog(true) : onChange(checked);
                    }}
                  />
                </Grid>
                {!skip && openDialog && (
                  <SwitchDialog
                    open={openDialog}
                    onClose={handleCancel}
                    onSave={() => handleConfirm(onChange, !value)}
                    title={switchDialogHelper[name].header}
                    body={switchDialogHelper[name].subHeader}
                    switchIcon={switchDialogHelper[name].showIcon}
                  />
                )}
              </>
            </Grid>
          )}
        />
      </Box>
    </Box>
  );
};
